var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectionField',{attrs:{"disabled":_vm.disabled,"value":_vm.item,"items":_vm.items,"multiple":""},on:{"change":_vm.setValues}})}
var staticRenderFns = []

export { render, staticRenderFns }